export enum EUserActions {
  fetchUserDataSuccess = 'fetchuserData/success',
  fetchuserDataError = 'fetchuserData/error',
}
